document.addEventListener('DOMContentLoaded', function () {
  var scrollTopBtn = document.querySelector('#ovensmash-26-pre-bottom .scrollTop');

  if (!scrollTopBtn) return;

  // Ẩn nút lúc đầu (bằng class để có animation)
  scrollTopBtn.classList.remove('is-visible');

  // Click: scroll lên đầu và ẩn nút
  scrollTopBtn.addEventListener('click', function (e) {
    e.preventDefault();

    // Cuộn về top cho nhiều trường hợp layout khác nhau
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    scrollTopBtn.classList.remove('is-visible');
  });

  // Hiện/ẩn nút theo vị trí scroll
  window.addEventListener('scroll', function () {
    if (window.scrollY > 200) {
      scrollTopBtn.classList.add('is-visible');
    } else {
      scrollTopBtn.classList.remove('is-visible');
    }
  });
});